import React, { useState } from 'react';
import logo from '../images/PGDost.png';
import photo from '../images/photo.jpg';
import { useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

export const Navbar = () => {
  const [isloogedin , setisloogedin] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  useEffect(() => {
    if (localStorage.getItem('email') != null && localStorage.getItem('password') != null) {
      setisloogedin(true);
    }
  });
  const handlelogin = () => {
    localStorage.removeItem("email");
        localStorage.removeItem("password");
    navigate('/');
  };
  const handleyourpost= () => {
    
    navigate('/createpost');
  };
  const handlehome= () => {
    
    navigate('/home');
  };
  const handleyourpost2= () => {
    
    navigate('/yourposts');
  };
  const handleyourpost3= () => {
    
    navigate('/myprofile');
  };
  const handleyourpost4= () => {
    
    navigate('/requests');
  };
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if(localStorage.getItem('email')){
        const response = await fetch(`https://pgdost.onrender.com/api/currentuser?email=${localStorage.getItem('email')}`);
        const data = await response.json();

        if (data.name && data.profilePic) {
          setisloogedin(true)
          setUserData(data);
        }
      }
      } catch (error) {
        console.error(error);
      }
    };

    fetchUserData();
  }, []);

  const twofunction = () =>{
       closeMenu();
       handleyourpost();

  };
  const twofunction4= () =>{
    closeMenu();
   
    handleyourpost4();

};
  const twofunction3 = () =>{
    closeMenu();
    handleyourpost3();

};
  
  const twofunction2 = () =>{
    closeMenu();
    handleyourpost2();

};
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="bg-white-500  border-b-2 border-gray-200 ">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
      <a href="/login" className="flex items-center space-x-3 rtl:space-x-reverse">
        <img src={logo} className="h-12 w-12 rounded-full object-cover" alt="PGDost Logo" />
        <span className="self-center text-2xl font-semibold whitespace-nowrap ">PGDost</span>
      </a>
        <div className="flex items-center md:order-2 space-x-3 md:space-x-10 rtl:space-x-reverse relative">
          <button
            type="button"
            className="flex text-sm bg-gray-800 rounded-full md:me-0 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600 relative z-10"
            id="user-menu-button"
            onClick={toggleMenu}
          >
            <span className="sr-only">Open user menu</span>
            { isloogedin && <img className="w-12 h-12 rounded-full" src={userData.profilePic} alt="user photo" />}
          </button>

          {isMenuOpen && isloogedin && (
            <div
            className="absolute right-0 mt-72 w-48 bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600 z-50" // Add z-50 to set a higher z-index
            id="user-dropdown"
          >
              <div className="px-4 py-3">
                <span className="block text-sm text-gray-900 dark:text-white">{userData.name}</span>
                <span className="block text-sm text-gray-500 truncate dark:text-gray-400">{userData.email}</span>
              </div>
              <ul className="py-2" aria-labelledby="user-menu-button">
                <li>
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white" onClick={twofunction3}>
                    Profile
                  </a>
                </li>
                <li>
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white" onClick={twofunction}>
                   Create New Post
                  </a>
                </li>
                <li>
                  <a href="" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white" onClick={twofunction2}>
                   Your Posts
                  </a>
                </li>
                <li>
                  <a href="" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white" onClick={twofunction4}>
                   Requests
                  </a>
                </li>
                
                <li>
                  <a href="" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white" onClick={handlelogin}>
                    Sign out
                  </a>
                </li>
              </ul>
            </div>
          )}
            { isloogedin &&
          <div className="ml-3">
            <button
              type="button"
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            onClick={handlehome}
            >
              All Rooms
            </button>
          </div>
           }
        </div>
      </div>
    </nav>
  );
};
